import { withInstall } from '@xzx-design/utils'
import _Radio from './src/radio.tsx'
import _RadioGroup from './src/radio-group.tsx'

export const Radio = withInstall(_Radio)
export const RadioGroup = withInstall(_RadioGroup)
export default Radio

export * from './src/radio'
export * from './src/radio-group'
export * from './src/types'
